<script>
  import Clock from "./Clock.svelte";
  import { appState } from "../lib/Store";
  let state;
  appState.subscribe((s) => (state = s));
  const logout = () => {
    appState.set({ user: null });
  };
</script>

<div class="Toolbar">
  <div class="rightnav">
    <Clock />
    {#if state?.user != undefined}
      <b on:click={logout}>Logout</b>
    {/if}
  </div>
</div>

<style>
  .Toolbar {
    display: grid;
    background-color: rgb(136, 156, 178);
    opacity: 0.7;
    color: #fff;
    padding: 1em;
    border-radius: 0 0 0.5em;
    transition: 0.8s;
    overflow: hidden;
    z-index: 1;
    font-size: 1rem;
    margin: 0;
    width: 100%;
  }
  div.rightnav {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  b {
    margin-left: 2rem;
    font-weight: 200;
    cursor: pointer;
  }
</style>
